import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SurveyModel } from './../../../models/people/people.model';

@Component({
  selector: 'app-survey-list',
  templateUrl: './survey-list.component.html',
  styleUrls: ['./survey-list.component.less']
})
export class SurveyListComponent implements OnInit {

  @Input() showSurveyList: boolean;
  @Input() surveyList: SurveyModel[];
  @Output() showSurveyListChange = new EventEmitter<boolean>();

  choosenSurveyId: number;
  @Output() choosenSurvey = new EventEmitter<number>();


  constructor() { }

  ngOnInit() {
    // console.log(this.surveyList);
    //this.choosenSurvey
  }

  cancel() {
    this.showSurveyListChange.emit(false);
  }

  close() {
    // console.log(this.choosenSurveyId);
    this.choosenSurvey.emit(this.choosenSurveyId);
    this.showSurveyListChange.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/people/survey-list/survey-list.component.ts